import * as React from 'react';
import PropTypes from 'prop-types';
var SvgNavigationGroupNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7A2.5 2.5 0 108 4.5 2.5 2.5 0 0010.5 7zm0-4A1.5 1.5 0 119 4.5 1.5 1.5 0 0110.5 3zM10.5 8a7.17 7.17 0 00-3 .6 5.59 5.59 0 011.18.64A7.15 7.15 0 0110.5 9c1 0 3.5.53 3.5 1.6s-.35 1.4-.35 1.4H10a5.06 5.06 0 01-.16 1h3.82a1 1 0 00.69-.28A2.83 2.83 0 0015 10.6C15 8.46 11.39 8 10.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C2.33 9 0 9.81 0 11.6a2.83 2.83 0 00.66 2.12 1 1 0 00.69.28h6.3a1 1 0 00.69-.28A2.83 2.83 0 009 11.6C9 9.46 5.39 9 4.5 9zm3.15 4h-6.3S1 12.67 1 11.6 3 10 4.5 10c1 0 3.5.53 3.5 1.6S7.65 13 7.65 13zM4.5 8A2.5 2.5 0 102 5.5 2.5 2.5 0 004.5 8zm0-4A1.5 1.5 0 113 5.5 1.5 1.5 0 014.5 4z"
  }));
});
SvgNavigationGroupNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgNavigationGroupNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgNavigationGroupNormalXsmall;